import type {ReactElement} from 'react';
import {useAiChat} from '@AiChat/providers/ai-chat.context';
import {useAiChatSize} from '@AiChat/hooks/useAiChatSize';
import {AiChatWindowInspirations, aiChatWindowInspirationsData} from '@AiChat/components/ai-chat-window-inspirations';
import {useAiPromptBox} from '@Components/ai-prompt-box/hooks/useAiPromptBox';
import styles from './ai-chat-empty-state-content.module.scss';

export function AiChatEmptyStateContent(): ReactElement | null {
  const {state} = useAiChat();
  const {isSmall} = useAiChatSize();
  const {actions: promptBoxActions} = useAiPromptBox(state.promptBoxId);

  if (state.currentChatId || state.isPromptBoxOnly || state.isQuickTipsView || state.isAssetsView || state.isMemoryView) {
    return null;
  }

  if (state.isReturningUser) {
    return (
      <div className={styles.returningUserBackgroundClip}>
        <div className={`${styles.returningUserBackground} ${isSmall ? styles.returningUserBackgroundMobile : ''}`} />
      </div>
    );
  }

  return <AiChatWindowInspirations inspirations={aiChatWindowInspirationsData(promptBoxActions.update)} />;
}
